// 师徒新人培养 - 后台管理端接口
// 注意：管理端 baseURL 已含 /api，故路径从 /mentor 开始
import request from '../utils/request';

// 师徒关系（管理端全量分页）
export const mentorAdminRelations = (params) =>
  request({ url: '/applete/mentor/admin/relations', method: 'GET', params });
export const mentorAdminUnpair = (params) =>
  request({ url: '/applete/mentor/admin/unpair', method: 'POST', params });
export const mentorAdminDeleteRelation = (params) =>
  request({ url: '/applete/mentor/admin/deleteRelation', method: 'POST', params });
// 阶段流转（商学院管理者操作：加添燃料→聚焦长板→实现价值）
export const mentorAdminChangeStage = (params) =>
  request({ url: '/applete/mentor/relation/changeStage', method: 'POST', params });
// 管理端批量结对（P0，HR 代建，支持跨校区跨城市）
// 注意：body 必须用对象包裹 rows（裸数组会被后端越权检测判 380）
export const mentorAdminImportPairs = (rows) =>
  request({ url: '/applete/mentor/admin/importPairs', method: 'POST', data: { rows } });
// 培养进度总览（单关系各环节完成情况）
export const mentorAdminProgress = (params) =>
  request({ url: '/applete/mentor/admin/progress', method: 'GET', params });
// 帮带时间轴（B3，单关系按环节聚合时间戳，H5/后台共用）
export const mentorTimeline = (params) =>
  request({ url: '/applete/mentor/relation/timeline', method: 'GET', params });
// 教练搜索（按姓名/手机号，用于结对选人）
export const mentorSearchCoach = (params) =>
  request({ url: '/sys/coach/coachByNameOrPhone', method: 'GET', params });

// 任务（管理端全量分页 + 接收/提交统计）
export const mentorAdminTasks = (params) =>
  request({ url: '/applete/mentor/admin/tasks', method: 'GET', params });
export const mentorAdminTaskReceivers = (params) =>
  request({ url: '/applete/mentor/admin/taskReceivers', method: 'GET', params });
export const mentorTaskReceiverDetail = (params) =>
  request({ url: '/applete/mentor/task/receiverDetail', method: 'GET', params });

// 催办（决策7，管理端直接调 notice 接口）
export const mentorNoticeUrgeSubmit = (params) =>
  request({ url: '/applete/mentor/notice/urgeSubmit', method: 'POST', params });
export const mentorNoticeUrgeOverdue = (params) =>
  request({ url: '/applete/mentor/notice/urgeOverdue', method: 'POST', params });
export const mentorNoticeSubmitSummary = (params) =>
  request({ url: '/applete/mentor/notice/submitSummary', method: 'POST', params });

// 雷达 / 考核查看
export const mentorRadar = (params) =>
  request({ url: '/applete/mentor/form/radar', method: 'GET', params });
export const mentorRadarPage = (params) =>
  request({ url: '/applete/mentor/form/radarPage', method: 'GET', params });
export const mentorFormHistory = (params) =>
  request({ url: '/applete/mentor/form/history', method: 'GET', params });

// 任务模板库（B2）
export const mentorTaskTemplates = (params) =>
  request({ url: '/applete/mentor/admin/taskTemplates', method: 'GET', params });
export const mentorTaskTemplatesAll = (params) =>
  request({ url: '/applete/mentor/admin/taskTemplatesAll', method: 'GET', params });
export const mentorTaskTemplateSave = (data) =>
  request({ url: '/applete/mentor/admin/taskTemplate/save', method: 'POST', data });
export const mentorTaskTemplateDelete = (params) =>
  request({ url: '/applete/mentor/admin/taskTemplate/delete', method: 'POST', params });
// 下发任务（管理员代发，publisherType=0）
export const mentorTaskPublish = (params) =>
  request({ url: '/applete/mentor/task/publish', method: 'POST', params });

// 第一阶段成果归档（D1）
export const mentorArchiveList = (params) =>
  request({ url: '/applete/mentor/admin/archiveList', method: 'GET', params });
export const mentorArchiveAreas = (params) =>
  request({ url: '/applete/mentor/admin/archiveAreas', method: 'GET', params });
export const mentorArchiveDownload = (params) =>
  request({ url: '/applete/mentor/admin/archiveDownload', method: 'POST', params });

// 第二阶段归档：职业画像聚合（工具1-5 + 表1/2/3 + 雷达，与 H5 画像同源）
export const mentorFormProfile = (params) =>
  request({ url: '/applete/mentor/form/profile', method: 'GET', params });

// 催办漏斗规则（B4）
export const mentorNoticeRules = (params) =>
  request({ url: '/applete/mentor/admin/noticeRules', method: 'GET', params });
export const mentorNoticeRuleSave = (data) =>
  request({ url: '/applete/mentor/admin/noticeRule/save', method: 'POST', data });

//目标完成（业绩目标/完成量分页查询）
// 注意：后端 @PostMapping + @RequestBody，必须走 JSON body，不能用 params（否则后端报 400 缺少请求体）
export const selectPerformanceByParam = (data) =>
    request({ url: '/applete/mentor/admin/selectPerformanceByParam', method: 'POST', data });
// 导出业绩（后端返回 JSON 提示，无文件流）
export const exportPerformanceByParam = (data) =>
    request({ url: '/applete/mentor/admin/exportPerformanceByParam', method: 'POST', data });